import styled from 'styled-components';
import { GameSelectorPrev } from '../../molecules/GameSelectorNav/GameSelectorNav.styled';

const GameReturnStyled = styled(GameSelectorPrev)`
  height: 30px;
  left: 70px;
  position: fixed;
  top: 35px;
  width: 30px;
  z-index: ${props => props.theme.zIndex.return};

  svg {
    transform: translate(0, 0);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    top: 45px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    height: 40px;
    left: 3vw;
    top: 40px;
    width: 40px;
  }
`;

export const SVGReturn = styled.svg`
  fill: ${props => props.theme.colors.white};
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 30px;

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    height: 40px;
    transform: translate(-1px, -2px);
    width: 40px;
  }
`;

export default GameReturnStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/GameReturn/GameReturn.styled.js